import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'start-planning-card',
  templateUrl: './start-planning-card.component.html',
  styleUrl: './start-planning-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StartPlanningCardComponent {
  @Output() startPlanning = new EventEmitter();
}
